import React from 'react';

function Schedule() {
        return <p>Schedule Page</p>
}

export default Schedule;